<template>
  <v-navigation-drawer
    v-model="drawer"
    @input="onClose"
    right
    app
    temporary
    width="600"
    class="pa-4"
  >
    <p class="title" @click="close()">
      {{ id ? "Alteração" : "Cadastro" }} de cliente
      <v-btn icon class="float-right">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </p>
    <v-divider class="mb-4"></v-divider>

    <FormularioGerenciarCliente
      ref="formularioGerenciarCliente"
      @salvar="this.salvar"
      :id="id"
    />
  </v-navigation-drawer>
</template>

<script>
import { api } from "../../../../api";
import FormularioGerenciarCliente from "../forms/FormularioGerenciarCliente.vue";

export default {
  name: "IziManNavigationDrawerGerenciarCliente",
  components: { FormularioGerenciarCliente },
  data() {
    return {
      id: null,
      drawer: false,
    };
  },
  methods: {
    show(id = null) {
      this.id = id;
      this.drawer = true;
    },

    close() {
      this.drawer = false;
    },

    onClose(event) {
      if (!event) {
        this.id = null;
        this.$refs.formularioGerenciarCliente.$refs.form.reset();
        this.$refs.formularioGerenciarCliente.resetaZipCode();
      }
    },

    async salvar(body) {
      try {
        const response = !this.id
          ? await api.post("/client", body)
          : await api.put(`/client/${this.id}`, body);

        if (response.data) {
          this.$root.GlobalMessage.success("Operação realizada com sucesso!");
          this.$refs.formularioGerenciarCliente.$refs.form.reset();
          this.$emit("salvo", response.data);
          this.close();
        } else this.$root.GlobalMessage.error("Erro ao cadastrar Cliente!");
      } catch (err) {
        this.$root.GlobalMessage.error(
          "Erro ao realizar requisição, entre em contato com o administrador!"
        );
      }
    },
  },
};
</script>
